<!--
部门员工列表
-->
<template>
	<div>
		<el-dialog title="部门员工" :visible.sync="dialogVisible" :close-on-click-modal="false" v-el-drag-dialog>
			<div class="my-table">
				<el-table :data="list" v-loading="loading">
					<el-table-column label="员工编号" prop="id" width="80" show-overflow-tooltip>
						<template slot-scope="scope">
							<span class="row-code">{{ scope.row.userId }}</span>
						</template>
					</el-table-column>
					<el-table-column label="员工姓名" prop="nickname" width="150" show-overflow-tooltip>
						<template slot-scope="scope">
							<div class="flex-col-center">
								<img class="row-header" :src="scope.row.avatar" />
								<span>{{ scope.row.name }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="员工电话" prop="tel" show-overflow-tooltip></el-table-column>
					<el-table-column label="员工角色" prop="role" show-overflow-tooltip></el-table-column>
					<el-table-column label="加入时间" prop="joinTime" width="180" show-overflow-tooltip></el-table-column>
					<el-table-column label="操作" prop="id" width="80" show-overflow-tooltip>
						<template slot-scope="scope">
							<div class="row-btns" v-if="show">
								<el-tooltip class="item" effect="dark" content="删除" placement="top">
									<img src="@/assets/images/yggl_icon_sc.png" @click="delUser(scope.row.userId)" />
								</el-tooltip>
							</div>
							<div v-else>暂无操作</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination background layout="prev, pager, next" :total="total" :page-size="5" :current-page.sync="page"
				@current-change="getList" class="box-paging">
			</el-pagination>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				id: '', // 部门id
				list: [],
				page: 1,
				total: 1,

				loading: false,

				dialogVisible: false,

				show: false
			}
		},
		computed: {},
		watch: {},
		mounted() {},
		methods: {
			open(id, show) {
				this.id = id
				this.list = []
				this.page = 1
				this.total = 1
				this.show = show
				this.dialogVisible = true
				this.getList()
			},

			getList() {
				this.loading = true
				this.$api.organization.deptWorkerList({
					deptId: this.id,
					keyword: '',
					limit: 5,
					page: this.page
				}).then(({
					data
				}) => {
					this.loading = false
					if (data.code == 200) {
						this.list = data.data
						this.total = data.total
					}
				}).catch(() => {
					this.loading = false
				})
			},

			delUser(id) {
				this.$confirm('此操作将删除该部门员工, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.$api.organization.deleteDeptUser({
							deptId: this.id,
							userId: id
						}).then(({
							data
						}) => {
							if (data.code == 200) {
								if (this.total % 10 == 1 && this.page != 1) this
									.page-- // 若当前删除的为当前页最后一个 则page-1
								this.$notify.success({
									title: '提示',
									message: '删除成功'
								})
								this.getList()
								this.$emit('refresh')
							}
						})
					})
					.catch(() => {})
			},

			close() {
				this.dialogVisible = false
			}
		}
	}
</script>
<style lang="scss" scoped>
	/deep/ .my-table {
		.el-table__row>td>.cell {
			background: rgba(248, 250, 255, 0.5);
			border-top: 1px solid #eff1f4;
			border-bottom: 1px solid #eff1f4;
		}

		.el-table__row>td {
			&:last-child {
				.cell {
					border-right: 1px solid #eff1f4;
				}
			}

			&:first-child {
				.cell {
					border-left: 1px solid #eff1f4;
				}
			}
		}
	}
</style>
